import styled from 'styled-components';

interface ModalProps {
  isOpen?: boolean;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
}

interface ModalOverlayProps {
  isOpen?: boolean;
}

export const ModalOverlay = styled.div<ModalOverlayProps>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: ${props => props.isOpen ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
`;

export const ModalContainer = styled.div<ModalProps>`
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  max-height: 90vh;
  overflow-y: auto;
  width: 100%;
  max-width: ${props => {
    switch (props.size) {
      case 'small': return '400px';
      case 'medium': return '600px';
      case 'large': return '800px';
      case 'xlarge': return '1200px';
      default: return '600px';
    }
  }};
  position: relative;
`;

export const ModalHeader = styled.div`
  padding: 1.5rem 1.5rem 0 1.5rem;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

export const ModalTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
  margin: 0;
`;

export const ModalCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background: #f3f4f6;
    color: #374151;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
  }
`;

export const ModalBody = styled.div`
  padding: 0 1.5rem 1.5rem 1.5rem;
`;

export const ModalFooter = styled.div`
  padding: 1rem 1.5rem 1.5rem 1.5rem;
  border-top: 1px solid #e5e7eb;
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
`;

// Specialized modal variants
export const ConfirmationModal = styled(ModalContainer)`
  max-width: 400px;
`;

export const FormModal = styled(ModalContainer)`
  max-width: 600px;
`;

export const FullScreenModal = styled(ModalContainer)`
  max-width: 95vw;
  max-height: 95vh;
  margin: 2.5vh auto;
`;